module.exports = __webpack_public_path__ + "media/images/telefono_corona2-f4083b1c78c2ee3349cf0cdfb3880a47.jpg";